import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Avatar from 'vue-avatar';

@Component({
  name: 'bpc-contact-card',
  components: {
    Avatar,
  },
})
export default class ContactCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;

  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }

  get contactEmail() {
    return this.item.contact_detail?.email1 || this.item.contact_detail?.email2;
  }

  get contactPhone() {
    return (
      this.item.contact_detail?.phone1 ||
      this.item.contact_detail?.phone2 ||
      this.item.contact_detail?.phone3
    );
  }
  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  get imgUrl() {
    if (this.imgFail) {
      return null;
    }
    return this.item.photo_contact[this.currentImgField];
  }

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
